import '@mdxeditor/editor/style.css';
import './editor.style.css';
import React, { useEffect, useRef } from 'react';
import { Box } from 'investira.react.components';
import {
  MDXEditor,
  headingsPlugin,
  listsPlugin,
  quotePlugin,
  toolbarPlugin,
  markdownShortcutPlugin,
  BoldItalicUnderlineToggles,
  ListsToggle
} from '@mdxeditor/editor';

function MdEditor(props) {
  const { id, markdown = '', onBlur, onChange, isSelected } = props;

  const editorRef = useRef();

  const handleBlur = e => {
    onBlur && onBlur(e, id);
  };

  useEffect(() => {
    const xMarkdownAtual = editorRef.current?.getMarkdown?.();

    if (xMarkdownAtual !== markdown) {
      editorRef.current?.setMarkdown?.(markdown);
    }
  }, [markdown]);

  useEffect(() => {
    // Implementar um autofocus condicional
    if (isSelected && editorRef.current) {
      editorRef.current.focus();
    }
  }, [isSelected, id]);

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'secondary.lightness',
        borderRadius: 2
      }}>
      <MDXEditor
        ref={editorRef}
        markdown={markdown}
        contentEditableClassName="inv-mdxeditor-prose"
        onBlur={e => handleBlur(e, id)}
        onChange={onChange}
        plugins={[
          headingsPlugin(),
          listsPlugin(),
          quotePlugin(),
          markdownShortcutPlugin(),
          toolbarPlugin({
            toolbarClassName: 'inv-mdxeditor-toolbar',
            toolbarContents: () => (
              <>
                <BoldItalicUnderlineToggles />
                <ListsToggle />
              </>
            )
          })
        ]}
      />
    </Box>
  );
}

export default MdEditor;
